// import React, { useEffect, useState, useCallback } from 'react';
// import {
//   Box,
//   Button,
//   Typography,
//   Grid,
//   TableContainer,
//   Table,
//   TableHead,
//   TableBody,
//   Paper,
//   Modal,
//   IconButton,
//   DialogContent,
//   MenuItem,
//   TablePagination, 
// } from '@mui/material';
// import {
//   BootstrapDialog,
//   BootstrapDialogTitle,
//   Breadcrumb,
//   CTSinput,
//   CTSRinput,
//   StyledTableCell,
//   StyledTableRow,
// } from '../../reusableComponent/Reusables';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { useForm, Controller } from 'react-hook-form';
// import CloseIcon from '@mui/icons-material/Close';
// import { Print } from '@mui/icons-material';
// import styles from '../../../styles.module.css';
// import dayjs from 'dayjs';
// import ReusableSnackbar from '../../reusableComponent/ReusableSnackbar';
// import productionentryService from '../../../services/productionentry.Service';
// import plantMasterService from '../../../services/masters/plantMaster.Service';

// const printStyles = `
//   /* Hide .print-header-info by default (on screen) */
//   .print-header-info {
//     display: none;
//   }

//   @media print {
//     /* Show .print-header-info only on print */
//     .print-header-info {
//       display: block !important;
//       margin-bottom: 10px;
//     }

//     body * {
//       visibility: hidden;
//     }

//     .printable-area, .printable-area * {
//       visibility: visible;
//     }

//     .printable-area {
//       position: absolute;
//       left: 0;
//       top: 0;
//       width: 100%;
//       overflow: visible !important;
//       height: auto !important;
//       max-height: none !important;
//     }

//     .printable-table {
//       width: 100% !important;
//       border-collapse: collapse !important;
//       overflow: visible !important;
//     }

//     .printable-table thead {
//       display: table-header-group;
//     }

//     .printable-table tbody {
//       display: table-row-group;
//     }

//     .MuiPaper-root,
//     .MuiTableContainer-root {
//       overflow: visible !important;
//       max-height: none !important;
//       box-shadow: none !important;
//     }

//     .no-print {
//       display: none !important;

//     }
//   }
// `;




// const ProductionReport = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const editData = location.state || null;

//   const login_details = sessionStorage.getItem('loginUser');
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;
//   const depot_id = userInfo.depot_id;
//   const plant_id = userInfo.plant_id;

//   const [successMessage, setSuccessMessage] = useState('');
//   const [displayData, setDisplayData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [openModal, setOpenModal] = useState(false);
//   const [selectedImage, setSelectedImage] = useState('');
//   const [plant, setPlant] = useState([]);
//   const [info, setInfo] = useState([]);
//   const [openDetail, setDetail] = useState(false);
//   // Pagination state
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [totalCount, setTotalCount] = useState(0); // Renamed to camelCase for consistency

//   const {
//     control,
//     watch,
//     formState: { errors },
//     setError,
//   } = useForm({
//     defaultValues: {
//       entry_date_from: editData?.entry_date ? dayjs(editData.entry_date).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
//       entry_date_to: '',
//       plant: '',
//     },
//   });

//   const entryDateFrom = watch('entry_date_from');
//   const entryDateTo = watch('entry_date_to');
//   const selectedPlant = watch('plant');

//   useEffect(() => {
//     async function fetchPlantData() {
//       try {
//         setLoading(true);
//         const plantData = await plantMasterService.getPlantList({
//           page: 0,
//           size: 999,
//           searchKey: '',
//         });
//         setPlant(plantData || []);
//       } catch (error) {
//         console.error('Error fetching plant data:', error);
//         setSuccessMessage('Error fetching plant data');
//         setPlant([]);
//       } finally {
//         setLoading(false);
//       }
//     }
//     fetchPlantData();

//     const styleSheet = document.createElement('style');
//     styleSheet.type = 'text/css';
//     styleSheet.innerText = printStyles;
//     document.head.appendChild(styleSheet);

//     return () => {
//       document.head.removeChild(styleSheet);
//     };
//   }, []);

//   const handleShow = useCallback(async (formData) => {
//     const { entry_date_from, entry_date_to, plant } = formData;

//     // Manual validation
//     if (!entry_date_from) {
//       setError('entry_date_from', { message: 'From Date is required' });
//       return;
//     }

//     if (!entry_date_to) {
//       setError('entry_date_to', { message: 'To Date is required' });
//       return;
//     }

//     if (!plant) {
//       setError('plant', { message: 'Plant is required' });
//       return;
//     }

//     if (dayjs(entry_date_to).isBefore(dayjs(entry_date_from))) {
//       setError('entry_date_to', { message: 'To Date cannot be before From Date' });
//       return;
//     }

//     try {
//       setLoading(true);
//       setDisplayData([]);

//       const filterParams = {
//         page,
//         size: rowsPerPage,
//         searchKey: '',
//         fromDate: entry_date_from,
//         toDate: entry_date_to,
//         short_code: plant === 'all' ? '' : plant,
//       };

//       const response = await productionentryService.getProductionEntryReport(filterParams);
//       let fetchedData = response?.data || response || [];
//       const total = response?.total_count || fetchedData.length || 0; // Adjust based on API response structure

//       // Client-side filtering as a fallback if API doesn't filter by short_code
//       if (plant !== 'all') {
//         fetchedData = fetchedData.filter(row => row.short_code === plant);
//       }

//       setDisplayData(fetchedData);
//       setTotalCount(total);
//     } catch (error) {
//       console.error('Error fetching data:', error);
//       setDisplayData([]);
//       setTotalCount(0);
//     } finally {
//       setLoading(false);
//     }
//   }, [setError, page, rowsPerPage]);

//   useEffect(() => {
//     if (entryDateFrom && entryDateTo && selectedPlant && !errors.entry_date_from && !errors.entry_date_to && !errors.plant) {
//       handleShow({
//         entry_date_from: entryDateFrom,
//         entry_date_to: entryDateTo,
//         plant: selectedPlant,
//       });
//     }
//   }, [entryDateFrom, entryDateTo, selectedPlant, errors, handleShow]);

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0); // Reset to first page when rows per page changes
//   };

//   const handleImageClick = (image) => {
//     setSelectedImage(image);
//     setOpenModal(true);
//   };

//   const handleCloseModal = () => {
//     setOpenModal(false);
//     setSelectedImage('');
//   };

//   const handlePrint = () => {
//     window.print();
//   };

//   const handleDetails = (tableData) => {
//     const parsedData = JSON.parse(tableData);
//     setInfo(parsedData);
//     setDetail(true);
//   };

//   const dateConversion = (date) => {
//     if (!date) return '';
//     const today = new Date(date);
//     const dd = String(today.getDate()).padStart(2, '0');
//     const mm = String(today.getMonth() + 1).padStart(2, '0');
//     const yyyy = today.getFullYear();
//     return `${dd}/${mm}/${yyyy}`;
//   };

//   const handleClose = () => {
//     setDetail(false);
//   };

//   const getPlantName = (short_code) => {
//     const plantData = plant.find((p) => p.short_code === short_code);
//     return plantData?.plant_name || short_code || 'Unknown';
//   };
//   useEffect(() => {
//     const styleSheet = document.createElement('style');
//     styleSheet.type = 'text/css';
//     styleSheet.innerText = printStyles;
//     document.head.appendChild(styleSheet);

//     return () => {
//       document.head.removeChild(styleSheet);
//     };
//   }, []);

//   return (
//     <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
//       <Box className={styles.body}>
//         <Breadcrumb routeSegments={[{ name: 'Production Report' }]} />
//         <Typography className={styles.header_txt}>PRODUCTION REPORT</Typography>

//         <form className="no-print">
//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={6} md={4}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography className={styles.label_Txt_add}>From Date</Typography>
//                 <Controller
//                   name="entry_date_from"
//                   control={control}
//                   render={({ field }) => (
//                     <CTSRinput
//                       size="small"
//                       fullWidth
//                       type="date"
//                       {...field}
//                       error={!!errors.entry_date_from}
//                       helperText={errors.entry_date_from?.message}
//                       InputProps={{ className: styles.CTSinput_Box }}
//                     />
//                   )}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography className={styles.label_Txt_add}>To Date</Typography>
//                 <Controller
//                   name="entry_date_to"
//                   control={control}
//                   render={({ field }) => (
//                     <CTSRinput
//                       size="small"
//                       fullWidth
//                       type="date"
//                       {...field}
//                       error={!!errors.entry_date_to}
//                       helperText={errors.entry_date_to?.message}
//                       InputProps={{ className: styles.CTSinput_Box }}
//                     />
//                   )}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography className={styles.label_Txt_add}>Plant</Typography>
//                 <Controller
//                   name="plant"
//                   control={control}
//                   rules={{ required: 'Plant is required' }}
//                   render={({ field }) => (
//                     <CTSRinput
//                       select
//                       size="small"
//                       fullWidth
//                       {...field}
//                       error={!!errors.plant}
//                       helperText={errors.plant?.message}
//                       InputProps={{ className: styles.CTSinput_Box }}
//                     >
//                       <MenuItem value="">Select Plant</MenuItem>
//                       <MenuItem value="all">All Plants</MenuItem>
//                       {plant.map((plantItem) => (
//                         <MenuItem key={plantItem.short_code} value={plantItem.short_code}>
//                           {plantItem.plant_name}
//                         </MenuItem>
//                       ))}
//                     </CTSRinput>
//                   )}
//                 />
//               </Box>
//             </Grid>
//           </Grid>
//         </form>

//         <Grid item xs={12} sx={{ mt: 4 }}>
//           <Paper sx={{ width: '100%' }}>
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '10px' }}>
//               <Button
//                 variant="outlined"
//                 startIcon={<Print />}
//                 onClick={handlePrint}
//                 disabled={displayData.length === 0}
//                 className="no-print"
//               >
//                 Print
//               </Button>
//             </Box>


//             {/* ✅ Wrap this in a div with class printable-area */}
//             <div className="printable-area">
//               <div className="print-header-info" style={{ marginBottom: '20px' }}>
//                 <Typography variant="h4" align="left" sx={{ fontWeight: 'bold' }}>
//                   Production Report
//                 </Typography>
//                 <Typography variant="body1" align="left" sx={{ marginTop: 1 }}>
//                   From: {entryDateFrom} &nbsp;&nbsp; | &nbsp;&nbsp; To: {entryDateTo} &nbsp;&nbsp; | &nbsp;&nbsp; Plant: {selectedPlant === 'all' ? 'All Plants' : getPlantName(selectedPlant)}
//                 </Typography>
//               </div>
//               <TableContainer component={Paper} className={`${styles.list_tbl_container} printable-table`}>
//                 <Table size="small" stickyHeader className="printable-table">
//                   <TableHead>
//                     <StyledTableRow>
//                       <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft:'5px' }}>Sr No</StyledTableCell>
//                       <StyledTableCell  sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Entry No</StyledTableCell>
//                       <StyledTableCell  sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Date</StyledTableCell>
//                       <StyledTableCell  sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Batch No</StyledTableCell>
//                       <StyledTableCell  sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Batch Date</StyledTableCell>
//                       <StyledTableCell  sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Shift</StyledTableCell>
//                       <StyledTableCell  sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Batch Start Time</StyledTableCell>
//                       <StyledTableCell  sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Batch End Time</StyledTableCell>
//                       <StyledTableCell  sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Filling Duration</StyledTableCell>
//                       <StyledTableCell  sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Product Description</StyledTableCell>
//                       <StyledTableCell  sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Product Code</StyledTableCell>
//                       <StyledTableCell  sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Plant Name</StyledTableCell>
//                       <StyledTableCell  sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>No Of Cyl</StyledTableCell>
//                     </StyledTableRow>
//                   </TableHead>

//                   <TableBody sx={{ backgroundColor: '#fff' }}>
//                     {loading ? (
//                       <StyledTableRow>
//                         <StyledTableCell colSpan={13} align="center">
//                           <Typography>Loading data...</Typography>
//                         </StyledTableCell>
//                       </StyledTableRow>
//                     ) : displayData.length === 0 ? (
//                       <StyledTableRow>
//                         <StyledTableCell colSpan={13} align="center">
//                           <Typography>No data found</Typography>
//                         </StyledTableCell>
//                       </StyledTableRow>
//                     ) : (
//                       displayData.map((row, index) => (
//                         <StyledTableRow key={index}>
//                           <StyledTableCell align="left">{index + 1}</StyledTableCell>
//                           <StyledTableCell align="left" className={styles.inspection_cell}>{row.entry_no}</StyledTableCell>
//                           <StyledTableCell align="left" className={styles.inspection_cell}>{dateConversion(row.entry_date)}</StyledTableCell>
//                           <StyledTableCell align="left" className={styles.inspection_cell}>{row.batch_no}</StyledTableCell>
//                           <StyledTableCell align="left" className={styles.inspection_cell}>{dateConversion(row.batch_date)}</StyledTableCell>
//                           <StyledTableCell align="left" className={styles.inspection_cell}>{row.shift}</StyledTableCell>
//                           <StyledTableCell align="left" className={styles.inspection_cell}>{row.batch_start_time}</StyledTableCell>
//                           <StyledTableCell align="left" className={styles.inspection_cell}>{row.batch_end_time}</StyledTableCell>
//                           <StyledTableCell align="left" className={styles.inspection_cell}>{row.filling_duration}</StyledTableCell>
//                           <StyledTableCell align="left" className={styles.inspection_cell}>{row.prod_description}</StyledTableCell>
//                           <StyledTableCell align="left" className={styles.inspection_cell}>{row.prod_code}</StyledTableCell>
//                           <StyledTableCell align="left" className={styles.inspection_cell}>
//                             {getPlantName(row.short_code)}
//                           </StyledTableCell>
//                           <StyledTableCell
//                             align="left"
//                             className={styles.inspection_cell}
//                             sx={{ color: 'blue', cursor: 'pointer' }}
//                             onClick={() => handleDetails(row.child_details)}
//                           >
//                             {JSON.parse(row.child_details)?.length || 0}
//                           </StyledTableCell>
//                         </StyledTableRow>
//                       ))
//                     )}
//                   </TableBody>
//                 </Table>
//               </TableContainer>

//             </div>

//             <TablePagination
//               className="no-print"
//               rowsPerPageOptions={[10, 25, 100]}
//               component="div"
//               count={totalCount}
//               rowsPerPage={rowsPerPage}
//               page={page}
//               onPageChange={handleChangePage}
//               onRowsPerPageChange={handleChangeRowsPerPage}
//             />
//           </Paper>
//         </Grid>


//         <ReusableSnackbar
//           open={!!successMessage}
//           onClose={() => setSuccessMessage('')}
//           message={successMessage}
//           autoHideDuration={2000}
//           vertical="top"
//           horizontal="right"
//           className="no-print"
//         />

//         <Modal
//           open={openModal}
//           onClose={handleCloseModal}
//           aria-labelledby="image-modal-title"
//           aria-describedby="image-modal-description"
//           sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
//           className="no-print"
//         >
//           <Box
//             sx={{
//               position: 'relative',
//               maxWidth: '90%',
//               maxHeight: '90%',
//               bgcolor: 'background.paper',
//               boxShadow: 24,
//               p: 2,
//               borderRadius: 2,
//               display: 'flex',
//               justifyContent: 'center',
//               alignItems: 'center',
//             }}
//           >
//             <IconButton
//               sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}
//               onClick={handleCloseModal}
//               aria-label="Close image modal"
//             >
//               <CloseIcon />
//             </IconButton>
//             <img
//               src={selectedImage}
//               alt="Full-size receipt"
//               style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
//               onError={(e) => {
//                 e.target.onerror = null;
//               }}
//             />
//           </Box>
//         </Modal>

//         <BootstrapDialog
//           PaperProps={{
//             sx: {
//               minWidth: '90%',
//               maxHeight: '90%',
//             },
//           }}
//           onClose={handleClose}
//           open={openDetail}
//         >
//           <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
//             Details
//           </BootstrapDialogTitle>
//           <DialogContent dividers>
//             <TableContainer component={Paper} className={`${styles.list_tbl_container} printable-table`}>
//               <Table size="small" stickyHeader className="printable-table">
//                 <TableHead className={styles.table_head_container}>
//                   <StyledTableRow>
//                     <StyledTableCell align="center">Sr No</StyledTableCell>
//                     <StyledTableCell align="left">Cylinder No</StyledTableCell>
//                     <StyledTableCell align="left">Tag No</StyledTableCell>
//                     <StyledTableCell align="left">Initial Wt</StyledTableCell>
//                     <StyledTableCell align="left">Final Wt</StyledTableCell>
//                     <StyledTableCell align="left">Qty Filled</StyledTableCell>
//                     <StyledTableCell align="left">Remarks</StyledTableCell>
//                   </StyledTableRow>
//                 </TableHead>
//                 <TableBody sx={{ backgroundColor: '#fff' }}>
//                   {info.map((row, index) => (
//                     <StyledTableRow key={index}>
//                       <StyledTableCell align="center">{row.sr_no}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.cyl_no}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.tag_no}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.initial_wt}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.final_wt}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.qty_filled + ' ' + row.uom}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.remarks}</StyledTableCell>
//                     </StyledTableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </DialogContent>
//         </BootstrapDialog>
//       </Box>
//     </Box>
//   );
// };

// export default ProductionReport;


import React, { useEffect, useState, useCallback } from 'react';
import {
  Box,
  Button,
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Paper,
  Modal,
  IconButton,
  DialogContent,
  MenuItem,
  Dialog,
} from '@mui/material';
import {
  Breadcrumb,
  CTSRinput,
  StyledTableCell,
  StyledTableRow,
} from '../../reusableComponent/Reusables';
import { useLocation } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { Print } from '@mui/icons-material';
import styles from '../../../styles.module.css';
import dayjs from 'dayjs';
import ReusableSnackbar from '../../reusableComponent/ReusableSnackbar';
import productionentryService from '../../../services/productionentry.Service';
import plantMasterService from '../../../services/masters/plantMaster.Service';
import CustomPagination from '../../reusableComponent/CustomPagination';
import { useSelector } from 'react-redux';

const printStyles = `
  .print-header-info { display: none; }
  @media print {
    .print-header-info { display: block !important; margin-bottom: 10px; }
    body * { visibility: hidden; }
    .printable-area, .printable-area * { visibility: visible; }
    .printable-area {
      position: absolute; left: 0; top: 0;
      width: 100%; overflow: visible !important;
      height: auto !important; max-height: none !important;
    }
    .printable-table {
      width: 100% !important;
      border-collapse: collapse !important;
      overflow: visible !important;
    }
    .printable-table thead { display: table-header-group; }
    .printable-table tbody { display: table-row-group; }
    .MuiPaper-root, .MuiTableContainer-root {
      overflow: visible !important;
      max-height: none !important;
      box-shadow: none !important;
    }
    .no-print { display: none !important; }
  }
`;

const ProductionReport = () => {
  const location = useLocation();
  const editData = location.state || null;

  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;

  const defaultRowsPerPage = useSelector((state) => state.grn?.rows_per_page || 15);

  const [successMessage, setSuccessMessage] = useState('');
  const [displayData, setDisplayData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [plant, setPlant] = useState([]);
  const [info, setInfo] = useState([]);
  const [openDetail, setDetail] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [totalCount, setTotalCount] = useState(0);

  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage,
  });

  const {
    control,
    watch,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      entry_date_from: editData?.entry_date
        ? dayjs(editData.entry_date).format('YYYY-MM-DD')
        : dayjs().format('YYYY-MM-DD'),
     entry_date_to: dayjs().format("YYYY-MM-DD"), 
      plant: '',
    },
  });

  const entryDateFrom = watch('entry_date_from');
  const entryDateTo = watch('entry_date_to');
  const selectedPlant = watch('plant');

  const dateConversion = (date) => {
    if (!date) return '';
    const today = new Date(date);
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const getPlantName = (short_code) => {
    const plantData = plant.find((p) => p.short_code === short_code);
    return plantData?.plant_name || short_code || 'Unknown';
  };

  const getSelectedPlantName = () => {
    if (selectedPlant === 'all') return 'All Plants';
    return getPlantName(selectedPlant);
  };

  const effectiveTotalCount = totalCount > 0 ? totalCount : displayData.length;

  // ── Effect 1: Plant list + print styles ──────────────────────────────────
  useEffect(() => {
    async function fetchPlantData() {
      try {
        setLoading(true);
        const plantData = await plantMasterService.getPlantList({ page: 0, size: 999, searchKey: '' });
        setPlant(plantData || []);
      } catch (error) {
        setSuccessMessage('Error fetching plant data');
        setPlant([]);
      } finally {
        setLoading(false);
      }
    }
    fetchPlantData();

    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);
    return () => { document.head.removeChild(styleSheet); };
  }, []);

  // ── Effect 2: Reset page when filters change ─────────────────────────────
  useEffect(() => {
    setController((prev) => ({ ...prev, page: 0 }));
  }, [entryDateFrom, entryDateTo, selectedPlant]);

  // ── Effect 3: Fetch data ──────────────────────────────────────────────────
  const handleShow = useCallback(async (formData) => {
    const { entry_date_from, entry_date_to, plant: plantVal } = formData;
    if (!entry_date_from) { setError('entry_date_from', { message: 'From Date is required' }); return; }
    if (!entry_date_to) { setError('entry_date_to', { message: 'To Date is required' }); return; }
    if (!plantVal) { setError('plant', { message: 'Plant is required' }); return; }
    if (dayjs(entry_date_to).isBefore(dayjs(entry_date_from))) {
      setError('entry_date_to', { message: 'To Date cannot be before From Date' }); return;
    }
    try {
      setLoading(true);
      setDisplayData([]);
      const filterParams = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: '',
        fromDate: entry_date_from,
        toDate: entry_date_to,
        short_code: plantVal === 'all' ? '' : plantVal,
      };
      const response = await productionentryService.getProductionEntryReport(filterParams);
      let fetchedData = response?.data || response || [];
      const total = response?.total_count ?? response?.totalCount ?? response?.count ?? fetchedData.length;
      if (plantVal !== 'all') {
        fetchedData = fetchedData.filter((row) => row.short_code === plantVal);
      }
      setDisplayData(fetchedData);
      setTotalCount(total);
    } catch (error) {
      setDisplayData([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  }, [setError, controller.page, controller.rowsPerPage]);

  useEffect(() => {
    if (entryDateFrom && entryDateTo && selectedPlant && !errors.entry_date_from && !errors.entry_date_to && !errors.plant) {
      handleShow({ entry_date_from: entryDateFrom, entry_date_to: entryDateTo, plant: selectedPlant });
    }
  }, [entryDateFrom, entryDateTo, selectedPlant, controller.page, controller.rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setController((prev) => ({ ...prev, page: newPage }));
  };
  const handleChangeRowsPerPage = (event) => {
    setController({ rowsPerPage: parseInt(event.target.value, 10), page: 0 });
  };

  const handleCloseModal = () => { setOpenModal(false); setSelectedImage(''); };
  const handlePrint = () => { window.print(); };

  // ── Entry No click → open detail dialog ──────────────────────────────────
  const handleDetails = (row) => {
    setSelectedRow(row);
    try { setInfo(JSON.parse(row.child_details || '[]')); } catch { setInfo([]); }
    setDetail(true);
  };
  const handleClose = () => { setDetail(false); setSelectedRow(null); setInfo([]); };

  const cylinderHeaders = [
    'Sr No', 'Cylinder No', 'Tag No', 'Initial Wt', 'Final Wt', 'Qty Filled', 'Remarks',
  ];

  return (
    <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={styles.body}>
        <Breadcrumb routeSegments={[{ name: 'Production Report' }]} />
        <Typography className={styles.header_txt}>PRODUCTION SUMMARY</Typography>

        {/* ── Filter Row ── */}
        <Box
          className="no-print"
          component="form"
          sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', gap: '12px', mb: 2, width: '100%' }}
        >
          {/* From Date */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 140px', minWidth: '150px', maxWidth: { xs: '100%', sm: '300px' } }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
              From Date <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Controller
              name="entry_date_from"
              control={control}
              render={({ field }) => (
                <CTSRinput
                  size="small" fullWidth type="date" {...field}
                  error={!!errors.entry_date_from}
                  helperText={errors.entry_date_from?.message}
                  InputProps={{ className: styles.CTSinput_Box }}
                />
              )}
            />
          </Box>

          {/* To Date */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 140px', minWidth: '150px', maxWidth: { xs: '100%', sm: '300px' } }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
              To Date <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Controller
              name="entry_date_to"
              control={control}
              render={({ field }) => (
                <CTSRinput
                  size="small" fullWidth type="date" {...field}
                  error={!!errors.entry_date_to}
                  helperText={errors.entry_date_to?.message}
                  InputProps={{ className: styles.CTSinput_Box }}
                />
              )}
            />
          </Box>

          {/* Plant */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '2 1 180px', minWidth: '150px', maxWidth: { xs: '100%', sm: '300px' } }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
              Plant <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Controller
              name="plant"
              control={control}
              rules={{ required: 'Plant is required' }}
              render={({ field }) => (
                <CTSRinput
                  select size="small" fullWidth {...field}
                  error={!!errors.plant}
                  helperText={errors.plant?.message}
                  InputProps={{ className: styles.CTSinput_Box }}
                >
                  {/* <MenuItem value="">Select Plant</MenuItem> */}
                  <MenuItem value="all">All Plants</MenuItem>
                  {plant.map((plantItem) => (
                    <MenuItem key={plantItem.short_code} value={plantItem.short_code}>
                      {plantItem.plant_name}
                    </MenuItem>
                  ))}
                </CTSRinput>
              )}
            />
          </Box>

          {/* Print Button */}
          <Box sx={{ display: 'flex', alignItems: 'flex-end', flex: '0 0 auto', ml: { xs: 'auto', sm: 0 } }}>
            <Button
              variant="outlined" startIcon={<Print />} onClick={handlePrint}
              disabled={displayData.length === 0} size="small"
              sx={{ whiteSpace: 'nowrap', height: '30px' }}
            >
              Print
            </Button>
          </Box>
        </Box>

        {/* ── Main Table ── */}
        <Grid item xs={12}>
          <Paper sx={{ width: '100%' }}>
            <div className="printable-area">
              <div className="print-header-info" style={{ marginBottom: '20px' }}>
                <Typography variant="h4" align="left" sx={{ fontWeight: 'bold' }}>Production Report</Typography>
                <Typography variant="body1" align="left" sx={{ marginTop: 1 }}>
                  From: {entryDateFrom} &nbsp;|&nbsp; To: {entryDateTo} &nbsp;|&nbsp; Plant: {getSelectedPlantName()}
                </Typography>
              </div>

              <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
                <Table size="small" stickyHeader className="printable-table">
                  <TableHead>
                    <StyledTableRow>
                      {['Sr No', 'Entry No', 'Date', 'Batch No', 'Batch Date', 'Shift',
                        'Batch Start Time', 'Batch End Time', 'Filling Duration',
                        'Product Description', 'Product Code', 'Plant Name', 'No Of Cyl'].map((h) => (
                        <StyledTableCell key={h} sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>
                          {h}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody sx={{ backgroundColor: '#fff' }}>
                    {loading ? (
                      <StyledTableRow>
                        <StyledTableCell colSpan={13} align="center">
                          <Typography>Loading data...</Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                    ) : displayData.length === 0 ? (
                      <StyledTableRow>
                        <StyledTableCell colSpan={13} align="center">
                          <Typography>No data found</Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                    ) : (
                      displayData.map((row, index) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell align="left">
                            {controller.page * controller.rowsPerPage + index + 1}
                          </StyledTableCell>

                          {/* ── Entry No — clickable link ── */}
                          <StyledTableCell onClick={() => handleDetails(row)}>
                            <Typography
                              sx={{
                                fontSize: '12px',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                color: '#1976d2 !important',
                                textDecoration: 'underline',
                              }}
                            >
                              {row.entry_no}
                            </Typography>
                          </StyledTableCell>

                          <StyledTableCell className={styles.inspection_cell}>{dateConversion(row.entry_date)}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.batch_no}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{dateConversion(row.batch_date)}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.shift}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.batch_start_time}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.batch_end_time}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.filling_duration}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.prod_description}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.prod_code}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{getPlantName(row.short_code)}</StyledTableCell>
                          <StyledTableCell align="left" className={styles.inspection_cell}>
                            {JSON.parse(row.child_details)?.length || 0}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

            <CustomPagination
              page={controller.page}
              rowsPerPage={controller.rowsPerPage}
              totalCount={effectiveTotalCount || 0}
              onPageChange={(newPage) => handleChangePage(null, newPage)}
              onRowsPerPageChange={handleChangeRowsPerPage}
              className="no-print"
            />
          </Paper>
        </Grid>

        {/* ── Snackbar ── */}
        <ReusableSnackbar
          open={!!successMessage}
          onClose={() => setSuccessMessage('')}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
          className="no-print"
        />

        {/* ── Image Modal ── */}
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          className="no-print"
        >
          <Box sx={{ position: 'relative', maxWidth: '90%', maxHeight: '90%', bgcolor: 'background.paper', boxShadow: 24, p: 2, borderRadius: 2, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <IconButton sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }} onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
            <img
              src={selectedImage} alt="Full-size"
              style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
            />
          </Box>
        </Modal>

        {/* ── Detail Dialog ── */}
        <Dialog
          open={openDetail}
          onClose={handleClose}
          maxWidth={false}
          className="no-print"
          sx={{
            '& .MuiDialog-paper': {
              margin: 'auto', width: '92vw', maxHeight: '85vh',
              boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
              overflow: 'hidden', fontFamily: "'Inter', Arial, sans-serif",
            },
          }}
        >
          {/* Header */}
          <Box sx={{ background: '#1C3A5E', padding: '14px 22px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#fff', letterSpacing: '0.5px', fontFamily: "'Inter', Arial, sans-serif" }}>
              PRODUCTION DETAILS
            </Typography>
            <IconButton onClick={handleClose} sx={{ color: '#fff', p: 0.5 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={{ padding: '20px 24px', background: '#F4F7FB', overflowY: 'auto' }}>

            {/* ── Entry Info Card ── */}
            <Box sx={{ background: '#fff', border: '1px solid #E2E8F0', overflow: 'hidden', mb: 2.5 }}>
              <Box sx={{ background: '#2A4F7A', padding: '9px 18px' }}>
                <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#fff', letterSpacing: '0.4px', fontFamily: "'Inter', Arial, sans-serif" }}>
                  📋 Entry Information
                </Typography>
              </Box>
              <Grid container>
                {[
                  { label: 'Entry No',          value: selectedRow?.entry_no,                        border: true,  bottom: true },
                  { label: 'Entry Date',         value: dateConversion(selectedRow?.entry_date),      border: true,  bottom: true },
                  { label: 'Batch No',           value: selectedRow?.batch_no,                        border: true,  bottom: true },
                  { label: 'Batch Date',         value: dateConversion(selectedRow?.batch_date),      border: false, bottom: true },
                  { label: 'Shift',              value: selectedRow?.shift,                           border: true,  bottom: true },
                  { label: 'Batch Start Time',   value: selectedRow?.batch_start_time,                border: true,  bottom: true },
                  { label: 'Batch End Time',     value: selectedRow?.batch_end_time,                  border: true,  bottom: true },
                  { label: 'Filling Duration',   value: selectedRow?.filling_duration,                border: false, bottom: true },
                  { label: 'Product Code',       value: selectedRow?.prod_code,                       border: true,  bottom: false },
                  { label: 'Product Description',value: selectedRow?.prod_description,                border: true,  bottom: false },
                  { label: 'Plant Name',         value: getPlantName(selectedRow?.short_code),        border: false, bottom: false },
                ].map(({ label, value, border, bottom }) => (
                  <Grid
                    key={label}
                    item xs={12} sm={6} md={3}
                    sx={{
                      borderRight: border ? '1px solid #EDF2F7' : 'none',
                      borderBottom: bottom ? '1px solid #EDF2F7' : 'none',
                      padding: '12px 16px',
                    }}
                  >
                    <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#718096', textTransform: 'uppercase', letterSpacing: '0.6px', mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      {label}
                    </Typography>
                    <Typography sx={{ fontSize: '14px', fontWeight: label === 'Entry No' ? 700 : 600, color: label === 'Entry No' ? '#1C3A5E' : '#2D3748', fontFamily: "'Inter', Arial, sans-serif" }}>
                      {value || 'N/A'}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* ── Cylinder Details Table ── */}
            <Box sx={{ background: '#fff', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
              {/* <Box sx={{ background: '#2A4F7A', padding: '9px 18px' }}>
                <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#fff', letterSpacing: '0.4px', fontFamily: "'Inter', Arial, sans-serif" }}>
                  🔵 Cylinder Details ({info.length})
                </Typography>
              </Box> */}
              <TableContainer sx={{ maxHeight: '350px' }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <StyledTableRow>
                      {cylinderHeaders.map((header) => (
                        <StyledTableCell
                          key={header} align="center"
                          sx={{
                            backgroundColor: '#1C3A5E !important',
                            color: '#fff !important',
                            fontFamily: "'Inter', Arial, sans-serif",
                            fontWeight: 700, fontSize: '11px',
                            padding: '10px 8px', whiteSpace: 'nowrap',
                            borderRight: '1px solid rgba(255,255,255,0.1)',
                          }}
                        >
                          {header}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {info.length > 0 ? (
                      info.map((row, index) => (
                        <StyledTableRow
                          key={index}
                          sx={{ backgroundColor: index % 2 === 0 ? '#fff' : '#F8FAFC', '&:hover': { backgroundColor: '#EBF4FF' } }}
                        >
                          {[
                            index + 1,
                            row.cyl_no || 'N/A',
                            row.tag_no || 'N/A',
                            row.initial_wt || 'N/A',
                            row.final_wt || 'N/A',
                            `${row.qty_filled || ''} ${row.uom || ''}`.trim() || 'N/A',
                            row.remarks || 'N/A',
                          ].map((val, ci) => (
                            <StyledTableCell
                              key={ci} align="center"
                              sx={{ fontSize: '11px', fontFamily: "'Inter', Arial, sans-serif", color: '#2D3748', padding: '8px 6px', borderBottom: '1px solid #EDF2F7', whiteSpace: 'nowrap' }}
                            >
                              {val}
                            </StyledTableCell>
                          ))}
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell
                          colSpan={cylinderHeaders.length} align="center"
                          sx={{ py: 5, fontSize: '13px', color: '#A0AEC0', fontFamily: "'Inter', Arial, sans-serif" }}
                        >
                          No cylinder details available
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </DialogContent>

          {/* Footer */}
          <Box sx={{ padding: '12px 24px', background: '#F8FAFC', borderTop: '1px solid #E2E8F0', display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              onClick={handleClose}
              sx={{
                background: '#E53E3E', color: '#fff', fontSize: '13px', fontWeight: 600,
                textTransform: 'none', padding: '7px 20px', borderRadius: '8px',
                fontFamily: "'Inter', Arial, sans-serif",
                '&:hover': { background: '#971f16' },
              }}
            >
              Close
            </Button>
          </Box>
        </Dialog>

      </Box>
    </Box>
  );
};

export default ProductionReport;